import angular from "angular";

angular
    .module('api-common')
    .factory('ApiInterceptorService', ApiInterceptorService)
    .config(configureInterceptor);

ApiInterceptorService.$inject = ['$q', '$injector', 'SENTINEL_API_HOST_CONSTANTS'];

export function ApiInterceptorService($q, $injector, HOST) {
    var interceptor = {
        request: requestInterceptor,
        responseError: responseErrorInterceptor
    };
    return interceptor;

    function requestInterceptor(config) {
        if (!_.startsWith(config.url, HOST.URL + '/')) {
            return config;
        }
        // Vision is a separate host in every build target today, but keep the guard so
        // cookie auth never leaks onto Vision requests if it is ever served under the API host.
        if (HOST.VISION_URL && _.startsWith(config.url, HOST.VISION_URL)) {
            return config;
        }
        config.headers = angular.extend({}, config.headers, {
            'X-Client-Version': 'insight1/' + HOST.CLIENT_VERSION
        });
        if (_.startsWith(config.url, HOST.URL + '/rest/1/devicerecovery/getDeviceRecoveryByToken')) {
            return config;
        }
        if (_.startsWith(config.url, HOST.URL + '/rest/1/devicerecovery/UpdateDeviceRecovery')) {
            return config;
        }

        if (_.startsWith(config.url, HOST.URL + '/auth/web/')) {
            return config;
        }

        const session = $injector.get('SentinelUiSession');
        config.__usesSentinelWebAuth = true;
        config.__webAuthGeneration = session.getGeneration();
        config.withCredentials = true;
        const headers = { 'Accept': 'application/json' };
        if (!config.headers['Content-Type']) {
            headers['Content-Type'] = 'application/json';
        }
        config.headers = angular.extend({}, config.headers, headers);
        delete config.headers.Authorization;
        delete config.headers.authorization;

        return config;
    }

    function responseErrorInterceptor(rejection) {
        const config = rejection.config || {};
        const isRecoverableRequest =
            rejection.status === 401 &&
            config.__usesSentinelWebAuth;

        if (!isRecoverableRequest) {
            return $q.reject(rejection);
        }

        const session = $injector.get('SentinelUiSession');
        if (config.__webAuthRetried) {
            if (config.__webAuthGeneration === session.getGeneration()) {
                session.expireSession();
            }
            return $q.reject(rejection);
        }

        return session.refreshAccessToken()
            .then(function () {
                const retryConfig = angular.copy(config);
                retryConfig.__webAuthRetried = true;
                retryConfig.__webAuthGeneration = session.getGeneration();
                retryConfig.withCredentials = true;
                retryConfig.headers = angular.extend({}, retryConfig.headers);
                delete retryConfig.headers.Authorization;
                delete retryConfig.headers.authorization;
                return $injector.get('$http')(retryConfig);
            }, function (refreshError) {
                session.handleRefreshFailure(refreshError);
                return $q.reject(refreshError);
            });
    }
}

configureInterceptor.$inject = ['$httpProvider'];

function configureInterceptor($httpProvider) {
    $httpProvider.interceptors.push('ApiInterceptorService');
}
